export default "__VITE_ASSET__D6do_VWh__"